import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Typography
} from '@material-ui/core'
import {
  ArrowRightLeft,
  MessageSquareMore,
  TriangleAlert,
  UserRound,
  Workflow
} from 'lucide-react'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import toastError from '../../errors/toastError'
import api from '../../services/api'
import SelectInput from '../SelectInput'
import { useStyles } from './style'

const AdvancedTransferRequestNotification = ({
  isOpen,
  onClose,
  ticketId,
  requestingUserName,
  requestingUserId,
  requestingUserProfile,
  requestingUserSuper,
  requestingUserQueues,
  requestedTargetQueueId,
  contactName,
  currentQueueName,
  currentQueueId
}) => {
  const classes = useStyles()
  const [availableQueues, setAvailableQueues] = useState(
    requestingUserQueues || []
  )
  const [selectedQueueId, setSelectedQueueId] = useState('')
  const [requesterProfile, setRequesterProfile] = useState(
    requestingUserProfile || ''
  )
  const [requesterSuper, setRequesterSuper] = useState(!!requestingUserSuper)
  const [loading, setLoading] = useState(true)

  const isPrivilegedRequester = ['admin', 'supervisor', 'super'].includes(
    String(requesterProfile || '').toLowerCase()
  ) || requesterSuper
  const canFallbackToCurrentQueue = isPrivilegedRequester && !!currentQueueId
  const canTransfer = !!selectedQueueId || canFallbackToCurrentQueue

  const getPreferredQueueId = queues => {
    if (!queues || queues.length === 0) {
      return ''
    }

    const requestedId = Number(requestedTargetQueueId)
    if (!Number.isNaN(requestedId) && requestedId > 0) {
      const hasRequestedQueue = queues.some(queue => queue.id === requestedId)
      if (hasRequestedQueue) {
        return String(requestedId)
      }
    }

    const hasAccessToCurrent = queues.some(queue => queue.id === currentQueueId)
    if (hasAccessToCurrent) {
      return String(currentQueueId)
    }

    return String(queues[0].id)
  }

  useEffect(() => {
    if (!isOpen || !requestingUserId) {
      setLoading(false)
      return
    }

    const notificationQueues = requestingUserQueues || []
    const hasNotificationUserData =
      notificationQueues.length > 0 ||
      !!requestingUserProfile ||
      !!requestingUserSuper

    if (hasNotificationUserData) {
      setRequesterProfile(requestingUserProfile || '')
      setRequesterSuper(!!requestingUserSuper)
      setAvailableQueues(notificationQueues)

      const preferredQueueId = getPreferredQueueId(notificationQueues)

      if (preferredQueueId) {
        setSelectedQueueId(preferredQueueId)
      } else if (
        (['admin', 'supervisor', 'super'].includes(
          String(requestingUserProfile || '').toLowerCase()
        ) ||
          requestingUserSuper) &&
        currentQueueId
      ) {
        setSelectedQueueId(String(currentQueueId))
      }

      setLoading(false)
      return
    }

    const fetchUserQueues = async () => {
      setLoading(true)
      try {
        const { data } = await api.get(`/users/${requestingUserId}`)
        const queues = data.queues || []
        setRequesterProfile(data.profile || '')
        setRequesterSuper(!!data.super)
        setAvailableQueues(queues)

        const preferredQueueId = getPreferredQueueId(queues)
        if (preferredQueueId) {
          setSelectedQueueId(preferredQueueId)
        } else if (
          ['admin', 'supervisor', 'super'].includes(
            String(data.profile || '').toLowerCase()
          ) &&
          currentQueueId
        ) {
          setSelectedQueueId(String(currentQueueId))
        }
      } catch (error) {
        console.error('Erro ao buscar departamentos do usuário:', error)
        toastError(error)
      } finally {
        setLoading(false)
      }
    }
    fetchUserQueues()
  }, [isOpen, requestingUserId, currentQueueId])

  useEffect(() => {
    if (!isOpen) {
      setSelectedQueueId('')
      setAvailableQueues([])
      setRequesterProfile('')
      setRequesterSuper(false)
      setLoading(true)
    }
  }, [isOpen])

  const handleTransfer = async () => {
    try {
      await api.post(`/tickets/${ticketId}/respond-transfer`, {
        action: 'accept',
        requestingUserId: requestingUserId,
        targetQueueId:
          selectedQueueId ||
          (canFallbackToCurrentQueue ? String(currentQueueId) : undefined)
      })

      const selectedQueue = availableQueues.find(
        q => q.id === parseInt(selectedQueueId)
      )
      const queueInfo = selectedQueue
        ? ` para o departamento ${selectedQueue.name}`
        : ''

      toast.success(
        `Atendimento transferido para ${requestingUserName}${queueInfo} com sucesso!`
      )
      onClose()
    } catch (error) {
      console.error('Erro ao transferir atendimento:', error)
      toastError(error)
    }
  }

  const handleReject = async () => {
    try {
      await api.post(`/tickets/${ticketId}/respond-transfer`, {
        action: 'reject',
        requestingUserId: requestingUserId
      })

      toast.info(
        `Solicitação de transferência de ${requestingUserName} foi rejeitada`
      )
      onClose()
    } catch (error) {
      console.error('Erro ao rejeitar transferência:', error)
      toastError(error)
    }
  }

  // const handleLater = () => {
  //   toast.info('Você pode responder a esta solicitação mais tarde')
  //   onClose()
  // }

  // if (loading) {
  //   return (
  //     <Box className={classes.notificationContainer}>
  //       <Typography>Carregando informações...</Typography>
  //     </Box>
  //   )
  // }

  // return (
  //   <Box className={classes.notificationContainer}>
  //     <Box className={classes.header}>
  //       <Typography className={classes.title}>
  //         Solicitação de Transferência
  //       </Typography>
  //       <Button className={classes.closeButton} onClick={onClose} size="small">
  //         <X size={16} />
  //       </Button>
  //     </Box>

  //     <Box className={classes.content}>
  //       <Typography className={classes.message}>
  //         <strong>{requestingUserName}</strong> solicitou a transferência do
  //         atendimento:
  //       </Typography>

  //       <Box className={classes.ticketInfo}>
  //         <Typography className={classes.ticketText}>
  //           <User size={14} />
  //           <strong>Contato:</strong> {contactName || 'Não identificado'}
  //         </Typography>
  //         <Typography className={classes.ticketText}>
  //           <ArrowRightLeft size={14} />
  //           <strong>Departamento Atual:</strong>{' '}
  //           {currentQueueName || 'Não definido'}
  //         </Typography>
  //         <Typography className={classes.ticketText}>
  //           <strong>Ticket:</strong> #{ticketId}
  //         </Typography>
  //       </Box>

  //       {availableQueues.length > 1 && (
  //         <Box className={classes.queueSelection}>
  //           <Typography className={classes.queueLabel}>
  //             <Settings size={14} />
  //             Escolha o departamento para transferência:
  //           </Typography>
  //           <FormControl className={classes.selectField} size="small">
  //             <Select
  //               value={selectedQueueId}
  //               onChange={e => setSelectedQueueId(e.target.value)}
  //               displayEmpty
  //             >
  //               {availableQueues.map(queue => (
  //                 <MenuItem key={queue.id} value={queue.id}>
  //                   {queue.name}
  //                   {queue.id === currentQueueId && (
  //                     <Chip
  //                       label="Atual"
  //                       size="small"
  //                       style={{ marginLeft: 8, backgroundColor: '#e3f2fd' }}
  //                     />
  //                   )}
  //                 </MenuItem>
  //               ))}
  //             </Select>
  //           </FormControl>
  //         </Box>
  //       )}

  //       {availableQueues.length === 0 && (
  //         <Box
  //           className={classes.queueSelection}
  //           style={{ backgroundColor: '#ffebee', borderColor: '#ffcdd2' }}
  //         >
  //           <Typography style={{ color: '#c62828', fontSize: '0.8rem' }}>
  //             ⚠️ O usuário {requestingUserName} não tem acesso a nenhum
  //             departamento.
  //           </Typography>
  //         </Box>
  //       )}
  //     </Box>

  //     <Box className={classes.actions}>
  //       <Button
  //         className={classes.laterButton}
  //         onClick={handleLater}
  //         size="small"
  //         variant="contained"
  //       >
  //         Depois
  //       </Button>
  //       <Button
  //         className={classes.rejectButton}
  //         onClick={handleReject}
  //         size="small"
  //         variant="contained"
  //       >
  //         Rejeitar
  //       </Button>
  //       <Button
  //         className={classes.transferButton}
  //         onClick={handleTransfer}
  //         size="small"
  //         variant="contained"
  //         disabled={availableQueues.length === 0 || !selectedQueueId}
  //       >
  //         Transferir
  //       </Button>
  //     </Box>
  //   </Box>
  // )

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="transfer-request-dialog-title"
      classes={{ paper: classes.dialogPaper }}
    >
      {loading ? (
        <Box className={classes.notificationContainer}>
          <Typography>Carregando informações...</Typography>
        </Box>
      ) : (
        <>
          <DialogTitle
            id="transfer-request-dialog-title"
            className={classes.dialogTitle}
          >
            Solicitação de Transferência
          </DialogTitle>

          <DialogContent dividers className={classes.dialogContent}>
            <Typography className={classes.message}>
              <strong className={classes.requestingUserName}>
                {requestingUserName}
              </strong>{' '}
              solicitou a transferência do atendimento:
            </Typography>

            <Box className={classes.ticketInfo}>
              <Typography className={classes.ticketText}>
                <UserRound size={16} />
                <strong>Contato:</strong> {contactName || 'Não identificado'}
              </Typography>
              <Typography className={classes.ticketText}>
                <ArrowRightLeft size={16} />
                <strong>Departamento Atual:</strong>{' '}
                {currentQueueName || 'Não definido'}
              </Typography>
              <Typography className={classes.ticketText}>
                <MessageSquareMore size={16} />
                <strong>Ticket:</strong> #{ticketId}
              </Typography>
            </Box>

            {availableQueues.length > 1 && (
              <Box className={classes.queueSelection}>
                <Typography className={classes.queueLabel}>
                  <Workflow size={16} />
                  Escolha o departamento para transferência:
                </Typography>
                <FormControl className={classes.selectField}>
                  <SelectInput
                    value={selectedQueueId}
                    onChange={e => setSelectedQueueId(e.target.value)}
                    variant="outlined"
                    displayEmpty
                    name="queue"
                  >
                    {availableQueues.map(queue => (
                      <MenuItem key={queue.id} value={queue.id}>
                        {queue.name}
                        {queue.id === currentQueueId && (
                          <span className={classes.currentQueueChip}>
                            atual
                          </span>
                        )}
                      </MenuItem>
                    ))}
                  </SelectInput>
                </FormControl>
              </Box>
            )}

            {availableQueues.length === 0 && (
              <Box
                className={classes.queueSelectionError}
              >
                <Typography className={classes.queueLabelError}>
                  <TriangleAlert size={18} />
                  {canFallbackToCurrentQueue
                    ? `O usuário ${requestingUserName} não tem departamentos vinculados. A transferência será mantida no departamento atual.`
                    : `O usuário ${requestingUserName} não tem acesso a nenhum departamento.`}
                </Typography>
              </Box>
            )}
          </DialogContent>

          <DialogActions className={classes.dialogActions}>
            <Button
              className={classes.rejectButton}
              onClick={handleReject}
              size="small"
              variant="contained"
            >
              Rejeitar
            </Button>
            <Button
              className={classes.transferButton}
              onClick={handleTransfer}
              size="small"
              variant="contained"
              disabled={!canTransfer}
            >
              Transferir
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

export default AdvancedTransferRequestNotification
